import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";
import get from "lodash/get";
import { CloseIcon } from "../../../arrow/components/Svgs/close-icon";
import { LiveIcon } from "../../../arrow/components/Svgs/liveicon";
import { PublishDateAndTime } from "../../atoms";
import { STATIC_KEYWORDS } from "../../../constants";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";
import "./highlights.m.css";
import { useSelector } from "react-redux";

const LiveBlogHighlights = ({ story, isOpen, setShowHighlights, scrollToCard }) => {
  const config = useSelector((state) => get(state, ["qt", "config"], {}));
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";
  const [topOffset, setTopOffset] = useState();

  const trackStoryInteraction = (eventAction, linkPosition) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const pageType = "story-page";
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: eventAction,
        link_position: linkPosition,
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const handleClose = (cardId, index) => () => {
    trackStoryInteraction("highlight_miniview_click", index + 1);
    scrollToCard(cardId);
    if (isMobile) {
      setShowHighlights(false);
    }
  };

  const handleScroll = () => {
    const breakingNews = document.querySelector(".breaking-news");
    const topOffsetPx = 72;
    const breakingNewsHeight = breakingNews ? breakingNews.offsetHeight : 0;
    setTopOffset(topOffsetPx + breakingNewsHeight);
  };

  useEffect(() => {
    handleScroll();
    const throttled = throttle(handleScroll, 200);
    window.addEventListener("scroll", throttled);
    return () => {
      window.removeEventListener("scroll", throttled);
    };
  }, []);

  return (
    <>
      {isOpen && <div styleName="blur-bg" />}
      <div styleName={`wrapper ${isOpen ? "open" : "close"}`}>
        <div styleName="highlights-wrapper" style={{ top: `${topOffset}px` }}>
          <div styleName="title">
            <h3>{STATIC_KEYWORDS.HIGHLIGHTS}</h3>
            <div onClick={() => setShowHighlights(false)} styleName="close-icon">
              <CloseIcon />
            </div>
          </div>

          <div styleName="highlights">
            {story?.cards?.map((card, index) => {
              const titleElement = card["story-elements"]?.find((e) => e.type === "title" && e.text?.length);
              if (!titleElement) return null;
              return (
                <div styleName="live-blog-card" key={card.id || index}>
                  <div styleName="timestamp">
                    <LiveIcon color="#C6554F" />
                    <PublishDateAndTime publishTime={card["card-added-at"]} />
                  </div>
                  <div onClick={handleClose(card.id, index)}>
                    <div styleName="highlight">
                      <h5>{titleElement.text}</h5>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

LiveBlogHighlights.propTypes = {
  story: PropTypes.object,
  isOpen: PropTypes.bool,
  setShowHighlights: PropTypes.func,
  scrollToCard: PropTypes.func,
};

export default LiveBlogHighlights;
